import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FHW_SEARCH_DATA_ID } from '../constants';
import { filtersSliceActions } from '../store/modules/filters/reducer';
import PartnersLocator from './PartnersLocator';
import { translationsSliceActions } from '../store/modules/translations/reducer';
import { OrganismFhwSearchProps } from '../model/global';
import { mapSliceActions } from '../store/modules/map/reducer';
import { fhwSliceActions } from '../store/modules/fhw/reducer';
import { apiUrlsSelector } from '../store/modules/fhw/selectors';
import { leadFunnelSliceActions } from '../store/modules/leadfunnel/reducer';

const FHWSearch = (): JSX.Element => {
	const dispatch = useDispatch();
	const apiUrls = useSelector(apiUrlsSelector);

	useEffect(() => {
		const data = document.getElementById(FHW_SEARCH_DATA_ID) as HTMLScriptElement;
		if (data) {
			const initdata = JSON.parse(data.innerText) as OrganismFhwSearchProps;
			dispatch(fhwSliceActions.setApiUrls(initdata.apiUrls));
			dispatch(filtersSliceActions.setPartnerCategories(initdata.partnerCategories));
			dispatch(translationsSliceActions.initTranslations(initdata.translations));
			dispatch(mapSliceActions.initMapInitialData(initdata.mapData));
			dispatch(leadFunnelSliceActions.initLeadFunnelUrl({ leadFunnelStandaloneUrl: initdata.leadFunnelStandaloneUrl }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!apiUrls) return <>Hola</>;

	return <PartnersLocator />;
};

export default FHWSearch;
